import React, { useEffect, useState } from 'react';
import Table1 from "../../../../../components/Common/TableContainer";

// Formik validation
import { useFormik } from "formik";
import QRCode from 'qrcode.react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Button, FormFeedback, Modal } from 'reactstrap';
import * as Yup from "yup";
import { getLabRequestSamples, resetCalendar } from '../../../../../store/actions';
import { BaseCustomButton, BaseCustomModal, BaseSelectComponent, GradientDecorationLine } from '../../../../../shared';
import { Input, Form } from 'antd';

export const AssignSampleToTestModal = ({ props, setShowModal, showModal, modalRespInfo, modalHeader }) => {

    // const rowInfoLabTestView = localStorage?.getItem("addInfoToTestViewRowInfo") ? JSON.parse(localStorage?.getItem("addInfoToTestViewRowInfo") ?? {}) : {}

    // console.log('rowInfoLabTestView: ', rowInfoLabTestView);

    const [searchData, setSearchData] = useState('');

    const [rowSampleIds, setRowSampleIds] = useState([]);

    const [check, setCheck] = useState();
    const [checkID, setCheckID] = useState();

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestSamples(`?limit=20&page=0&labRequest=${props?.match?.params?.id}`)); // Sólo obtengo los items que coincidan con el id de "Lab Request" y que tengan status "Completo"
    }, [])

    useEffect(() => {
        // console.log('datos de busqueda:', searchData);
        dispatch(getLabRequestSamples(`?limit=20&page=0&labRequest=${props?.match?.params?.id}&search=${searchData}`));
        setRowSampleIds([]);
    }, [searchData])

    const onSearch = () => {
        // TODO: Ya sabes que hacer
        // id="inputSearchData"
        setSearchData(document.getElementById("inputSearchData").value);
    }

    const clearSearch = () => {
        document.getElementById("inputSearchData").value = '';
        setSearchData('');
    }


    const { labRequestSamples, labRequestSample, loading, total, currentPage } = useSelector(state => ({
        labRequestSamples: state.labRequestSampleReducer.labRequestSamples,
        labRequestSample: state.labRequestSampleReducer.labRequestSample,
        loading: state.labRequestSampleReducer.loading,
        total: state.labRequestSampleReducer.total,
        currentPage: state.labRequestSampleReducer.currentPage,
    }), shallowEqual);

    // * Redux fin

    const digitsOnly = (value) => /^\d+$/.test(value);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            essays: '',
        },
        validationSchema: Yup.object({
            // testsPerSample: Yup.string().required("Defina el número de ensayos por muestra"),
            essays: Yup.string().test('Digits only', 'Defina el número de ensayos por muestra. (sólo puede contener números)', digitsOnly),
        }),
        onSubmit: (values, { resetForm }) => {
            // console.log('values: ', values);

            let filteredArray;
            let filteredArrayAux;
            let deletedRepeatedElementsArray;

            filteredArray = rowSampleIds.filter(rowTestId => rowTestId.checkStatus === true); // TODO: Ya lo filtramos, ahora tenemos que  eliminar los elementos repetidos.

            filteredArrayAux = filteredArray.map((item) => item.id);

            deletedRepeatedElementsArray = filteredArrayAux.filter((item, index) => { // Borrado de elementos repetidos de un array
                return filteredArrayAux.indexOf(item) === index;
            })
            // console.log('filteredArray: ', filteredArray);
            // console.log('filteredArrayAux: ', filteredArrayAux);
            // console.log('deletedRepeatedElementsArray: ', deletedRepeatedElementsArray);

            if (deletedRepeatedElementsArray.length > 0) {
                modalRespInfo(values, deletedRepeatedElementsArray); // TODO: Aqui le debo de mandar ya solo el array final filtrado y todo
                resetForm();
                setShowModal(false);
            }

            // if (rowSampleIds.length > 0) {
            //     // const valuesPost = {
            //     //     ...values, // Aqui solo viene el "essays"
            //     //     labRequestTest: rowInfoLabTestView.id,
            //     //     rowSampleIds: rowSampleIds, // Es un arreglo de los labRequestSample
            //     // }
            //     modalRespInfo(values, rowSampleIds);
            //     resetForm();
            //     setShowModal(false);
            // }
        }
    });

    // const { className } = props;

    const toggle = () => {
        clearSearch();
        setShowModal(false);
        validation.resetForm();
    }

    const onClosed = () => {
        setRowSampleIds([]);
        validation.resetForm();
    }

    const getPagination = (params) => {
        dispatch(getLabRequestSamples(`${params}&labRequest=${props?.match?.params?.id}&search=${searchData}`));
    }

    // const onSelected = (value) => { // "values" solo contiene el labRequestSample

    //     if (rowSampleIds.includes(value)) { // Si sí incluye el valor quiero que lo BORRE 
    //         // console.log('Ya estaba ese valor en el array, se va a Borrar');
    //         setRowSampleIds(rowSampleIds.filter((index) => value !== index)); // TODO: Revisar esto porque creo que esta mal
    //     } else { // Si NO incluye el valor quiero que lo AGREGUE
    //         // console.log('No estaba ese valor en el array, se va a Agregar');
    //         // setRowTestIds([...rowTestIds, value]);
    //         setRowSampleIds(rowSampleIds => [
    //             ...rowSampleIds,
    //             value,
    //         ]);
    //     }
    // }

    useEffect(() => {
        setRowSampleIds(rowSampleIds.map((element, index) => { //Actualiza el status de "checkStatus" de todos los value "UUID" que coincidan
            if (element.id === checkID) {
                return {
                    id: checkID,
                    checkStatus: check,
                }
            } else {
                return element;
            }
        }))
    }, [rowSampleIds.length])

    const onSelected = (value, checkStatus) => { // "value" ya es el "id" seleccionado; "checkStatus" es true o false que es el estdo actual del check

        setRowSampleIds(rowSampleIds => [ // Siempre agrega al array el id y el estatus seleccionado 
            ...rowSampleIds,
            {
                id: value, // value: 'UUID'
                checkStatus: checkStatus,
            }
        ]);

        setCheck(checkStatus);
        setCheckID(value)
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'No. muestra',
                // accessor: 'noMuestra',
                width: 130,
                Cell: ({ row }) => (
                    <div>
                        <div className='text-center mb-2'>Código de muestra: {row.original?.sampleControlIdentifier ?? '-'}</div>
                        <div className='text-center mb-1'>
                             <QRCode value={row.original?.sampleControlIdentifier ?? '-'} size={50} />
                        </div>
                        <div className='text-center'>Folio de muestra: {row.original?.serviceIdentifier ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Descripción de la muestra',
                // accessor: 'descMuestra',
                width: 260,
                Cell: ({ row }) => (
                    <div>
                        <div>{row?.original?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Cantidad',
                accessor: 'quantity',
                width: 65,
            },
            {
                Header: 'UM',
                // accessor: 'um',
                width: 75,
                Cell: ({ row }) => (
                    <div>
                        <div>{row?.original?.unitMeasure?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                width: 80,
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <input
                            className="form-check-input rounded-pill p-3"
                            type="checkbox"
                            id="checkboxNoLabel"
                            value=""
                            aria-label="..."
                            onClick={(e) => onSelected(row.original.id, e.target.checked)}
                        />
                    </div>
                ),
            },
        ],
        []
    )

    const data = [
        {
            noMuestra: 'Lo del QR Code',
            descMuestra: 'Grava Triturada Caliza 05-10 mm',
            quantity: '400',
            um: 'KG',
        }
    ]

    const pagination_element = (
        <div className='px-0 py-2'>
            <Table1
                currentPage={currentPage}
                getPagination={getPagination}
                total={total}
                loading={loading}
                isAddTableBorderStrap
                columns={columns}
                data={labRequestSamples}
            />
        </div>
    );

    const search_element = (
        <div className='px-4 mx-3 mb-4'>
            <div className="row p-0 m-0 d-flex align-items-center" style={{ maxWidth: '750px' }}>
                <div className='col-8 p-0 pe-2'>
                    <Input
                        type="search"
                        id="inputSearchData"
                        className="form-control rounded-3"
                        placeholder="Buscar"
                        aria-label="Search"
                    />
                </div>
                <div className='col-4 p-0'>
                    <BaseCustomButton
                        color="dark"
                        label="Buscar"
                        onClick={onSearch}
                        className="py-2 rounded-3 w-100"
                        icon="mdi mdi-magnify me-2"
                    />
                </div>
            </div>
        </div>
    );
    
    const essays_input_element = (
        <div className='px-4 mx-3 mb-4'>
            <div style={{ maxWidth: '200px' }}>
                <label className='text-primary mb-1'>Ensayos por muestra</label>
                <Input
                    name="essays"
                    className="form-control text-primary text-center rounded-3 w-100"
                    placeholder="Número"
                    type="number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.essays || ""}
                    invalid={validation.touched.essays && validation.errors.essays ? true : false}
                    onFocus={(e) => e.target.select()}
                />
                {validation.touched.essays && validation.errors.essays ? (
                    <div className="text-danger mt-1">{validation.errors.essays}</div>
                ) : null}
            </div>
        </div>
    );

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                label="Guardar"
                onClick={validation.handleSubmit}
                outline
                className="rounded-3 me-3 p-2"
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color="danger"
                label="Cancelar"
                onClick={toggle}
                outline
                className="rounded-3 me-3 p-2"
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );


    return (
        <>
            <BaseCustomModal
                title={<h4 className='text-primary ps-4 m-0'>{modalHeader}</h4>}
                onClosed={onClosed}
                isModalOpen={showModal}
                handleOk={validation.handleSubmit}
                handleCancel={toggle}
                width="55%"
                centered
                style={{ minHeight: '85vh', overflowY: 'auto' }}
                footer={null}
            >
                <Form
                    className="form-horizontal mt-3 mb-2"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <GradientDecorationLine />
                    {essays_input_element}
                    {search_element}
                    {pagination_element}
                    <GradientDecorationLine />
                    {buttons}
                </Form>

            </BaseCustomModal>
        </>
    )
}
